import { call, delay, put, takeLatest } from "redux-saga/effects";
import { toast } from "react-toastify";

import { startLoader, stopLoader } from "../../../../utils/commonFunctions";
import { CustomerRateActionTypes, CustomerRateActions } from "../../../actionTypes/master/customerRateActionTypes";
import { setPostApiStatus, setPutApiStatus } from "../../../actions/apiStatusActions";
import {
  createCustomerRateApi,
  editCustomerRateDataByIdApi,
  getCustomerRateDataByIdApi,
  getCustomerRateListApi,
} from "../../requests/master/customerRateRequests";
import {
  setCustomerRateDataById,
  setCustomerRateList,
  setCustomerRateListPageCount,
} from "../../../actions/master/customerRateActions";


function* createCustomerRateHandler(action: CustomerRateActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(createCustomerRateApi, action.payload);

    if (data.status) {
      toast.success(data?.message, {
        position: "top-right",
      });
      yield put(setPostApiStatus(true));
    } else {
      toast.error(data?.message, {
        position: "top-right",
      });
      yield put(setPostApiStatus(false));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPostApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

function* getCustomerRateListHandler(action: CustomerRateActionTypes) {
  yield delay(500);
  try {
    yield startLoader("transparent");

    const { data } = yield call(getCustomerRateListApi, action.payload);

    if (data.status) {
      yield put(setCustomerRateList(data?.data?.rows ?? []));
      yield put(setCustomerRateListPageCount(data?.data?.count ?? 0));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* getCustomerRateDataByIdHandler(action: CustomerRateActionTypes) {
  try {
    const { data } = yield call(getCustomerRateDataByIdApi, action.payload);
    if (data.status) {
      yield put(setCustomerRateDataById(data?.data));
    } else {
      toast.error(data?.message, {
        position: "top-right",
      });
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  }
}

function* editCustomerRateDataByIdHandler(action: CustomerRateActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(editCustomerRateDataByIdApi, action.payload);
    if (data.status) {
      toast.success(data.message, {
        position: "top-right",
      });
      yield put(setPutApiStatus(true));
    } else {
      toast.error(data?.message, {
        position: "top-right",
      });
      yield put(setPutApiStatus(false));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPutApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

export default function* customerRateSaga() {
  yield takeLatest(CustomerRateActions.CREATE_CUSTOMER_RATE, createCustomerRateHandler);
  yield takeLatest(CustomerRateActions.GET_CUSTOMER_RATE_LIST, getCustomerRateListHandler);
  yield takeLatest(CustomerRateActions.GET_CUSTOMER_RATE_DATA_BY_ID, getCustomerRateDataByIdHandler);
  yield takeLatest(CustomerRateActions.EDIT_CUSTOMER_RATE_DATA_BY_ID, editCustomerRateDataByIdHandler);
}
